angular.module('mtic.components.dashboards.student_general')
  .directive('studentDashboard', function (
    $http,
    $log,
    $timeout,
    TIMING_CONSTANTS,
    EventManager,
    StudentDataService,
    PlatformService,
    MapStateService,
    $window
  ) {
    return {
      templateUrl: 'template.html',
      scope: {
        selectedClass: '='
      },
      link: function (scope, element) {
        scope.moduleDataReady = false;

        var eventManager = new EventManager('studentModules', scope);
        var screen_width = 0;
        var is_mobile = navigator.userAgent.match(/Android/i) || (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
        if (is_mobile) {
          screen_width = window.screen.width
        } else {
          screen_width = window.innerWidth;
        }
        if(screen_width < 1200){
          var timer = is_mobile ? 500 : 0;
          $timeout(function(){
            eventManager.broadcast('student:toggle:Sidepanel', false);
          }, timer)
        }

        scope.$on('$destroy', function() {
          MapStateService.setActiveModule("");
        });

        var init = function(firstInit, triggerRefresh) {
          scope.moduleDataReady = false;
          scope.moduleMapData = null;
          StudentDataService.getModuleData(true)
          .then(function(moduleMapData){
            if(triggerRefresh) {
              $log.debug('[[studentDashboard]] RE-INITED (refresh)', moduleMapData)
              scope.moduleMapData = moduleMapData;
              $timeout(() => {
                eventManager.broadcast('app:module:refresh/ready', {})
              }, TIMING_CONSTANTS.STUDENT_DATA_REFRESH_DELAY_MS);
            }
            else if(firstInit) {
              $log.debug('[[studentDashboard]] RE-INITED (first)', moduleMapData)
              scope.moduleMapData = moduleMapData;
              eventManager.broadcast('app:secondary:opened',moduleMapData.resource_slug)
            }
            else{
              $log.debug('[[studentDashboard]] RE-INITED', moduleMapData)
              $timeout(function(){
                scope.moduleMapData = moduleMapData;
              }, TIMING_CONSTANTS.INSTANT);
            }
          })
        };

        // EVENT SETUP
        eventManager.listen('student:cycle:open', function (e) {
          init(true);
        });

        eventManager.listen('app:module:open', function (e) {
          init(false);
        });

        eventManager.listen('app:module:refresh', function (e) {
          init(false, true);
        });

        eventManager.listen('creating-items-done', function (e) {
          scope.moduleDataReady = true;
        });

        scope.$watch('selectedClass', function(selectedClass){
          if(selectedClass){
            $log.log('selectedClass: ' , selectedClass)
            eventManager.broadcast('student:cycle:open', {})
          }
        })

        /****** Setting Dashboard table height *****/
        scope.mEls = scope.mEls || {};
        var unwatch_dashboardTable = scope.$watch(()=>{
          scope.mEls.pageHeader = (scope.mEls.pageHeader || document.querySelector('#nav-display-for-certificate'));
          scope.mEls.dashboardHeader = (scope.mEls.dashboardHeader || document.querySelector('.inner-container .dashboard-header'));
          scope.mEls.dashboardTable = (scope.mEls.dashboardTable || document.querySelector('.inner-container .dashboard-table'));
          return !!(
            scope.mEls.pageHeader &&
            scope.mEls.pageHeader.clientHeight &&
            scope.mEls.dashboardHeader &&
            (PlatformService.isPhonePortrait() ? scope.mEls.dashboardHeader.clientHeight : true) &&
            scope.mEls.dashboardTable);
        },(rendered)=>{
          if(rendered){
            setDashboardTableHeight();
            unwatch_dashboardTable();
          }
        });
        function setDashboardTableHeight(){
          let remHeight = 0;
          [scope.mEls.pageHeader, scope.mEls.dashboardHeader].map((el)=>{remHeight += (el ? el.getBoundingClientRect().height : 0)});
          scope.mEls.dashboardTable.style.height = (window.innerHeight - remHeight) + 'px';
        }
        window.removeEventListener('resize', mOnResize_dashboardTable);
        window.addEventListener('resize', mOnResize_dashboardTable);
        function mOnResize_dashboardTable(){ // in case for some reason mobile browser changes visible viewport height (hides address bar etc)
          setDashboardTableHeight();
        }

      }
    }
  });
